import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as S from './styles';

const CloseIcon = ({ severidade, onClick }) => (
    <S.CloseButton severidade={severidade} aria-label="Fechar" onClick={onClick}>
        <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L13 13M13 1L1 13" strokeWidth="2" strokeLinecap="round" />
        </svg>
    </S.CloseButton>
);

const TopBanner = ({ alerta, onClose }) => {
    const [dismissed, setDismissed] = useState(false);

    if (!alerta || dismissed) return null;

    const { mensagem, cta_label, cta_url, severidade } = alerta;

    const handleClose = () => {
        setDismissed(true);
        if (typeof onClose === 'function') onClose();
    };

    const isExternal = cta_url && (cta_url.startsWith('http://') || cta_url.startsWith('https://'));

    return (
        <S.BannerContainer severidade={severidade}>
            <S.BannerMessage severidade={severidade}>{mensagem}</S.BannerMessage>

            {cta_label && cta_url && (
                isExternal ? (
                    <S.BannerCTA
                        href={cta_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        severidade={severidade}
                    >
                        {cta_label}
                    </S.BannerCTA>
                ) : (
                    <S.BannerCTA as={Link} to={cta_url} severidade={severidade}>
                        {cta_label}
                    </S.BannerCTA>
                )
            )}

            <CloseIcon severidade={severidade} onClick={handleClose} />
        </S.BannerContainer>
    );
};

export default TopBanner;
